// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!

/* tslint:disable */
export const VERSION = {
  version: "7.9.1",
  date: "2026-09-15T06:42:27.951Z",
  gitInfo: {
    dirty: false,
    raw: "00920ab96",
    hash: "00920ab96",
    distance: null,
    tag: null,
    semver: null,
    suffix: "00920ab96",
    semverString: null
  }
};
/* tslint:enable */
